var link_preview_default = {
  "fontElementMap": "eLL9I",
  "linkPreviewContainer": "mudZd",
  "linkPreview": "d9zBi",
  "linkPreviewImage": "D1w2f",
  "linkPreviewInfo": "bQEVU",
  "linkPreviewTitle": "bn0tI",
  "linkPreviewDescription": "FLQra",
  "linkPreviewUrl": "pT1Qq"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
